<template>
    <div class="page-content eye mb-60">
        <div class="center-text own-title mb-10">
            BOSS
        </div>
        <router-link class="d-block" :to="'eye-download'">
            <div class="caption round-medium caption-margins card eye-gradient-bg">
                <img :src="'images/mpower/eye/boss_banner2.png'" style="max-width: 100%; margin: 0 auto;" />
                <!-- <img :src="'images/mpower/eye/eye_text.gif'" style="max-width: 100%; margin: 0 auto;" /> -->
            </div>
        </router-link>
        <div class="custom-divider-full"></div>
        <div class="gallery-view-controls">
            <a @click="changeGrid(3)" href="#" :class="grid_3_active?'color-highlight':''"><i class="fa fa-th"></i></a>
            <a @click="changeGrid(2)" href="#" :class="grid_2_active?'color-highlight':''"><i class="fa fa-th-large"></i></a>
            <a @click="changeGrid(1)" href="#" :class="grid_1_active?'color-highlight':''"><i class="fa fa-bars"></i></a>
            <div class="clear"></div>
        </div>
        <div class="content mb-15">
            <div class="gallery-views" :class="[grid_style]">
                <!-- <a @click="showImage(0)" class="default-link" title="video 1">
                    <img src="images/mpower/eye/9.png" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a> -->
                <a @click="showImage(0)" class="default-link" title="video 1">
                    <img src="images/mpower/eye/1st.png" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(1)" class="default-link" title="video 2">
                    <img src="images/mpower/eye/2nd.png" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(2)" class="default-link" title="video 3">
                    <img src="images/mpower/eye/3rd.png" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(3)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/1.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(4)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/2.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(5)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/3.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(6)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/4.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(7)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/5.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(8)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/6.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(9)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/7.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(10)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/8.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(11)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/9.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(12)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/10.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(13)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/11.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(14)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/12.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(15)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/13.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(16)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/14.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(17)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/15.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(18)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/16.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
                <a @click="showImage(19)" class="default-link" title="image 1">
                    <img src="images/mpower/eye/2022/17.jpeg" class="preload-image round-small fixed-img responsive-image" alt="img">
                </a>
            </div>
            <div class="clear"></div>
        </div>
        <LightBox ref="lightbox_gallery" :media="media" :showLightBox="false" :showThumbs="false">
            <footer></footer>
        </LightBox>
    </div>
</template>
<style scoped>
.mb-10 {
    margin-bottom: 10px !important;
}
.mb-15 {
    margin-bottom: 15px !important;
}
.mb-30 {
    margin-bottom: 30px !important;
}
.mb-60 {
    margin-bottom: 60px !important;
}
.gallery-3-col a:nth-child(3n-1) {
    margin: auto 5%;
}
.gallery-3-col a {
    margin-bottom: 5%;
}
.gallery-3-col a {
    width: 30%;
    float: left;
}
.gallery-3-col a img {
    height: 17vw;
    object-fit: cover;
    width: 100%;
}
.gallery-2-col a:nth-child(2n-1) {
    margin-right: 5%;
}
.gallery-2-col a {
    width: 47.5%;
    margin-bottom: 5%;
    float: left;
}
.gallery-1-col a{
    width: 100%;
    margin-bottom: 5%;
}
.eye-gradient-bg {
  background : linear-gradient(120deg, rgba(218, 67, 123, 1) 0%, rgba(218, 69, 122, 1) 1.8%, rgba(227, 113, 90, 1) 45.87%, rgba(232, 141, 71, 1) 80.06%, rgba(234, 151, 64, 1) 100%);
  border-radius : 12px;
}
.lb-data .lb-number {
    display: none !important;
}
.gallery-2-col .fixed-img{
    height: 30vw;
    width: 100%;
    object-fit: cover;
}
@media(max-width: 1290px){
    .gallery-3-col a img {
        height: 23vw;
    }
}
</style>
<script>
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
export default {
    name: 'Eye',
    data(){
        return {
            grid_style: "gallery-3-col",
            grid_1_active: false,
            grid_2_active: false,
            grid_3_active: true,
            media: [
            // {
            //     thumb: 'images/mpower/eye/9.png',
            //     sources: [{
            //         src: 'images/video/AXA EYE Promotional Video (Version 2020).mp4',
            //         type: 'video/mp4'
            //     }],
            //     type: "video",
            //     //caption: '<h4>Monsters Inc.</h4>',
            //     width: '100%', // required
            //     height: 'auto', // required
            //     autoplay: true //Optional to autoplay video when lightbox opens
            // },
            {
                thumb: 'images/mpower/eye/1st.png',
                sources: [{
                    src: 'images/video/M7 BOSS Program_1st.MP4',
                    type: 'video/mp4'
                }],
                type: "video",
                //caption: '<h4>Monsters Inc.</h4>',
                width: '100%', // required
                height: 'auto', // required
                autoplay: true //Optional to autoplay video when lightbox opens
            },
            {
                thumb: 'images/mpower/eye/2nd.png',
                sources: [{
                    src: 'images/video/M7 BOSS Program_2nd.MP4',
                    type: 'video/mp4'
                }],
                type: "video",
                //caption: '<h4>Monsters Inc.</h4>',
                width: '100%', // required
                height: 'auto', // required
                autoplay: true //Optional to autoplay video when lightbox opens
            },
            {
                thumb: 'images/mpower/eye/3rd.png',
                sources: [{
                    src: 'images/video/M7 BOSS Program_3rd.MP4',
                    type: 'video/mp4'
                }],
                type: "video",
                //caption: '<h4>Monsters Inc.</h4>',
                width: '100%', // required
                height: 'auto', // required
                autoplay: true //Optional to autoplay video when lightbox opens
            },
            {
                thumb: 'images/mpower/eye/2022/1.jpeg',
                src: 'images/mpower/eye/2022/1.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/1.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/2.jpeg',
                src: 'images/mpower/eye/2022/2.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/2.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/3.jpeg',
                src: 'images/mpower/eye/2022/3.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/3.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/4.jpeg',
                src: 'images/mpower/eye/2022/4.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/4.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/5.jpeg',
                src: 'images/mpower/eye/2022/5.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/5.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/6.jpeg',
                src: 'images/mpower/eye/2022/6.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/6.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/7.jpeg',
                src: 'images/mpower/eye/2022/7.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/7.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/8.jpeg',
                src: 'images/mpower/eye/2022/8.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/8.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/9.jpeg',
                src: 'images/mpower/eye/2022/9.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/9.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/10.jpeg',
                src: 'images/mpower/eye/2022/10.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/10.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/11.jpeg',
                src: 'images/mpower/eye/2022/11.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/11.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/12.jpeg',
                src: 'images/mpower/eye/2022/12.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/12.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/13.jpeg',
                src: 'images/mpower/eye/2022/13.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/13.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/14.jpeg',
                src: 'images/mpower/eye/2022/14.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/14.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/15.jpeg',
                src: 'images/mpower/eye/2022/15.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/15.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/16.jpeg',
                src: 'images/mpower/eye/2022/16.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/16.jpeg' // Optional for displaying responsive images
            },{
                thumb: 'images/mpower/eye/2022/17.jpeg',
                src: 'images/mpower/eye/2022/17.jpeg',
                //caption: 'caption to display. receive <html> <b>tag</b>', // Optional
                srcset: 'images/mpower/eye/2022/17.jpeg' // Optional for displaying responsive images
            },
            ]
        }
    },
    components: {
        LightBox
    },
    methods: {
        changeGrid(param){
            switch(param){
                case 3:
                    this.grid_style = "gallery-3-col";
                    this.grid_3_active = true;
                    this.grid_2_active = false;
                    this.grid_1_active = false;
                    break;
                case 2:
                    this.grid_style = "gallery-2-col";
                    this.grid_3_active = false;
                    this.grid_2_active = true;
                    this.grid_1_active = false;
                    break;
                case 1:
                    this.grid_style = "gallery-1-col";
                    this.grid_3_active = false;
                    this.grid_2_active = false;
                    this.grid_1_active = true;
                    break;
            }
        },
        showImage(param) {
            this.$refs.lightbox_gallery.showImage(param)
        }
    }
}
</script>
